import React, { useState } from 'react';
import './Temporadas.css';
import { enviarCorreoPrueba } from '../../services/jugadoresService';

// Confirmación antes de mandar el correo de prueba a un jugador. Solo se abre
// para ADMIN. Muestra la dirección guardada (la que usará el servidor).
export default function ModalCorreoPrueba({ jugador, email, onEnviado, onCerrar }) {
  const [enviando, setEnviando] = useState(false);
  const [error, setError] = useState(null);

  const enviar = async () => {
    setEnviando(true);
    setError(null);
    try {
      await enviarCorreoPrueba(jugador.jugador_id);
      onEnviado(email);
    } catch (err) {
      setError(err.message || 'No se pudo enviar el correo.');
      setEnviando(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={(e) => e.target === e.currentTarget && !enviando && onCerrar()}>
      <div className="modal-box" role="dialog" aria-modal="true" aria-labelledby="correo-prueba-titulo">
        <h3 id="correo-prueba-titulo">Enviar correo de prueba</h3>
        <p>¿Estás seguro de que quieres mandar el correo a <strong>{email}</strong>?</p>
        <p style={{ color: 'var(--c-muted)', fontSize: '0.85rem' }}>
          Asunto: «Verificación del correo» · Cuerpo: «Esto es un correo de prueba».
        </p>
        {error && <p className="error-msg" role="alert">{error}</p>}
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" disabled={enviando} onClick={onCerrar}>Cancelar</button>
          <button type="button" className="btn btn-primary" disabled={enviando} onClick={enviar}>
            {enviando ? 'Enviando…' : 'Enviar'}
          </button>
        </div>
      </div>
    </div>
  );
}
